<div class="lightbox" (click)="close.emit()">
  <header class="lightbox__bar">
    <div class="lightbox__info">
      <p class="lightbox__title">{{ state.title }}</p>
      @if (state.photos.length > 1) {
        <span class="lightbox__counter">{{ counter }}</span>
      }
    </div>

    <button type="button" class="lightbox__close" (click)="close.emit()" aria-label="Cerrar">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </header>

  <figure
    class="lightbox__stage"
    (click)="$event.stopPropagation()"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
  >
    @if (state.photos.length > 1) {
      <button
        type="button"
        class="lightbox__arrow lightbox__arrow--prev"
        (click)="previous.emit()"
        aria-label="Foto anterior"
      >
        <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
      </button>
    }

    @for (photo of [currentPhoto]; track state.currentIndex) {
      <img class="lightbox__image" [src]="photo.url" [alt]="photo.title || state.title" />
    }

    @if (state.photos.length > 1) {
      <button
        type="button"
        class="lightbox__arrow lightbox__arrow--next"
        (click)="next.emit()"
        aria-label="Foto siguiente"
      >
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    }
  </figure>

  @if (state.photos.length > 1) {
    <div class="lightbox__thumbs" (click)="$event.stopPropagation()">
      @for (photo of state.photos; track photo.id || $index; let i = $index) {
        <button
          type="button"
          class="lightbox__thumb"
          [class.lightbox__thumb--active]="i === state.currentIndex"
          (click)="select.emit(i)"
        >
          <img [src]="photo.thumbnailUrl || photo.url" [alt]="photo.title || state.title" />
        </button>
      }
    </div>
  }
</div>
